import { render, staticRenderFns } from "./CorrelationData.vue?vue&type=template&id=b65cd660&scoped=true"
import script from "./CorrelationData.vue?vue&type=script&lang=js"
export * from "./CorrelationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65cd660",
  null
  
)

export default component.exports